// extracted by css-extract-rspack-plugin
export default {"BlockedSectionMessage":"BlockedSection-module__BlockedSectionMessage___SCh_","CircleOcticon":"BlockedSection-module__CircleOcticon__Qw2U5"};